import React, { useEffect, useRef, useState } from 'react';
import Input from './Input';

// Campo de busca + lista de resultados navegável por teclado, compartilhado pelos modais de
// ativo (nacional, substituição, internacional, complementar) para não quadruplicar a mesma
// lógica de setas/Enter em cada um.
const SearchableAssetResults = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  onClear,
  autoFocus = false,
  results = [],
  onSelectResult,
  renderResult,
  resultsMaxHeightClassName = 'max-h-48',
  children,
}) => {
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const listRef = useRef(null);

  useEffect(() => {
    setHighlightedIndex(-1);
  }, [results]);

  useEffect(() => {
    if (highlightedIndex < 0 || !listRef.current) return;

    listRef.current.children[highlightedIndex]?.scrollIntoView({ block: 'nearest' });
  }, [highlightedIndex]);

  const handleKeyDown = (e) => {
    if (!results.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.min(prev + 1, results.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const asset = results[highlightedIndex >= 0 ? highlightedIndex : 0];
      if (asset) onSelectResult(asset);
    }
  };

  return (
    <div className="relative">
      <Input
        name={name}
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onClear={onClear}
        onKeyDown={handleKeyDown}
        autoFocus={autoFocus}
      />

      {results.length > 0 && (
        <ul
          ref={listRef}
          className={`absolute z-50 w-full mt-1 border border-grayLight rounded-md bg-white shadow-lg ${resultsMaxHeightClassName} overflow-y-auto divide-y divide-grayExtraLight2`}
        >
          {results.map((asset, idx) => (
            <li
              key={asset.id}
              className={`px-4 py-3 hover:bg-bluePale cursor-pointer transition-colors text-blueDarker ${
                idx === highlightedIndex ? 'bg-blueLightest2' : ''
              }`}
              onClick={() => onSelectResult(asset)}
            >
              {renderResult(asset)}
            </li>
          ))}
        </ul>
      )}

      {children}
    </div>
  );
};

export default SearchableAssetResults;
